import PropTypes from 'prop-types';
// Custom component
import FaqText from './FaqText';

const ArticleBody = ({ content }) => (
  <FaqText dangerouslySetInnerHTML={{ __html: content }} id="FaqStyle" />
);

ArticleBody.propTypes = {
  content: PropTypes.string,
};

export default ArticleBody;
